import { BaseLayout } from '@ria-client/tw-shared-ui';
import { ProductCardRedesignCtaButton } from './cta-button';
import { CtaImage } from './cta-image';
import { CtaName } from './cta-name';
import type { ProductSectionProps } from './product-section';

export function DesktopProductSection({
  cta,
  ctaAnalytics,
  displayName,
  image,
  starRating,
  starRatingTooltip,
  reviewLink,
  federallyInsuredAnnotation,
}: ProductSectionProps) {
  return (
    <div className="flex w-full items-center gap-3">
      <CtaImage cta={cta} ctaAnalytics={ctaAnalytics} displayName={displayName} image={image} />
      <div className="flex grow flex-col gap-2">
        <CtaName cta={cta} ctaAnalytics={ctaAnalytics} displayName={displayName} />
        <BaseLayout
          reviewLink={reviewLink}
          starRating={starRating}
          starRatingTooltip={starRatingTooltip}
        />
      </div>
      <div className="w-[220px] shrink-0 lg:w-[244px]">
        <ProductCardRedesignCtaButton
          cta={cta}
          ctaAnalytics={ctaAnalytics}
          federallyInsuredAnnotation={federallyInsuredAnnotation}
        />
      </div>
    </div>
  );
}
